export function getMasterStageDataset() {
  return process.env.VUE_APP_ENV === 'prod' ? 'master_stage' : 'dev_master_stage';
}
export function getAllowedReadDataset() {
  //return process.env.VUE_APP_ENV === 'prod' ? 'sand_ibk_itcm_base' : 'dev_sand_ibk_itcm_base'
  return 'sand_ibk_itcm_base';
}
export var MASTER_STAGE_DATASET = getMasterStageDataset();
export var MAX_ATHENA_TABLE_NAME = 255;
export var R_LINK_SUFFIX = '_rlink';